import type { createActorContext } from "@xstate/react";
import { createContext } from "react";
import type createAppMachine from "./app.machine";

const AppActorRedirectContext = createContext<
	ReturnType<typeof createActorContext<ReturnType<typeof createAppMachine>>>
>(null as never);

export default AppActorRedirectContext;
